import Vue from 'vue';
// import 'reset-css';
import 'animate.css';
import dayjs from 'dayjs';
import lodash from 'lodash';

import {
  Button, ButtonGroup, Select, Form, FormItem, Input, InputNumber,
  Checkbox, Option, Collapse, CollapseItem, Carousel, CarouselItem, Message,
  Table, TableColumn, Card, Dialog, DatePicker, Menu, MenuItem, Submenu, MenuItemGroup,
  Pagination, Steps, Step, Radio, RadioGroup, Row, Col, Switch, MessageBox, Tree, Scrollbar,
  Cascader, Tabs, TabPane, Dropdown, DropdownItem, DropdownMenu, Link, Upload, Image, Avatar, Tooltip,
  Popover, Progress, Breadcrumb, BreadcrumbItem,
} from 'element-ui';
import './util/directives/index';
import SvgIcon from 'vue2-svg-icon/Icon.vue';

import messageEn from '@/assets/json/en.json';
import App from './App.vue';
import router from './router';
import store from './store';
import axClient from './services';
import './element-variables.scss';

import './assets/css/app.scss';

Vue.component(Button.name, Button);
Vue.component(Form.name, Form);
Vue.component(Select.name, Select);
Vue.component(FormItem.name, FormItem);
Vue.component(InputNumber.name, InputNumber);
Vue.component(Input.name, Input);
Vue.component(Checkbox.name, Checkbox);
Vue.component(Option.name, Option);
Vue.component(Collapse.name, Collapse);
Vue.component(CollapseItem.name, CollapseItem);
Vue.component(Carousel.name, Carousel);
Vue.component(CarouselItem.name, CarouselItem);
Vue.component(Table.name, Table);
Vue.component(TableColumn.name, TableColumn);
Vue.component(Card.name, Card);
Vue.component(Dialog.name, Dialog);
Vue.component(DatePicker.name, DatePicker);
Vue.component(Menu.name, Menu);
Vue.component(MenuItem.name, MenuItem);
Vue.component(Submenu.name, Submenu);
Vue.component(MenuItemGroup.name, MenuItemGroup);
Vue.component(Pagination.name, Pagination);
Vue.component(Steps.name, Steps);
Vue.component(Step.name, Step);
Vue.component(Radio.name, Radio);
Vue.component(RadioGroup.name, RadioGroup);
Vue.component(Row.name, Row);
Vue.component(Col.name, Col);
Vue.component(Switch.name, Switch);
Vue.component(Tree.name, Tree);
Vue.component(Cascader.name, Cascader);
Vue.component(ButtonGroup.name, ButtonGroup);
Vue.component(Tabs.name, Tabs);
Vue.component(TabPane.name, TabPane);
Vue.component(Dropdown.name, Dropdown);
Vue.component(DropdownItem.name, DropdownItem);
Vue.component(DropdownMenu.name, DropdownMenu);
Vue.component(Link.name, Link);
Vue.component(Upload.name, Upload);
Vue.component(Image.name, Image);
Vue.component(Scrollbar.name, Scrollbar);
Vue.component(Avatar.name, Avatar);
Vue.component(Tooltip.name, Tooltip);
Vue.component(Popover.name, Popover);
Vue.component(Progress.name, Progress);
Vue.component(Breadcrumb.name, Breadcrumb);
Vue.component(BreadcrumbItem.name, BreadcrumbItem);
Vue.component('SvgIcon', SvgIcon);
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype._ = lodash;
Vue.prototype.$http = axClient;
Vue.prototype.$getMessage = (id) => messageEn[id];
Vue.prototype.$time = dayjs;
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
